import { WorkflowOperationType } from '../../enums/WorkflowOperationType.enum';
import { WorkflowProcessor } from './WorkflowProcessor';
import { CreateWorkflowData, PatchWorkflowData } from '@monorepo/interfaces';
import { CreateWorkflowProcessor } from './CreateWorkflowProcessor';
import { PatchWorkflowProcessor } from './PatchWorkflowProcessor';

/**
 * Factory for creating the appropriate workflow processor based on operation type
 *
 * @description This factory class provides a centralized mechanism for instantiating
 * the correct workflow processor implementation based on the requested operation type.
 * It abstracts the creation logic from the clients, making it easier to extend with
 * additional processor types in the future.
 */
export class WorkflowProcessorFactory {
    /**
     * Creates and returns the appropriate workflow processor for the given operation type
     *
     * @param operationType {WorkflowOperationType} - The type of operation to create a processor for (CREATE or UPDATE)
     * @returns A workflow processor instance appropriate for the operation type
     * @throws Error if an unsupported operation type is provided
     */
    static createProcessor(
        operationType: WorkflowOperationType
    ): WorkflowProcessor<CreateWorkflowData | PatchWorkflowData> {
        switch (operationType) {
            case WorkflowOperationType.CREATE:
                return new CreateWorkflowProcessor();
            case WorkflowOperationType.UPDATE:
                return new PatchWorkflowProcessor();
            default:
                throw new Error(`Unsupported operation type: ${operationType}`);
        }
    }
}
